import moment from 'moment'

export const data = function() {
  let DEFAULT_FORM_VALUES = {
    unitGroupID: 0,
    unitGroupUnitID: 0,
    unitID: 0,
    name: ''
  }

  let DEFAULT_FORM_ERRORS = {
    name: ''
  }

  return {
    DEFAULT_FORM_VALUES,
    DEFAULT_FORM_ERRORS,
    formErrors: {
      ...DEFAULT_FORM_ERRORS
    },
    formData: {
      ...DEFAULT_FORM_VALUES
    },
    formComplete: false,
    loading: true,
    isDebug: true,
    confirmModal: false,
    formatDateFn: function(value) {
      return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
    },
    formatFn: function(value) {
      return value != null ? value : ''
    },
    formatNumberFn: function(value) {
      return value != null ? value : 0
    },
    selectedRow: null,
    unitGroupList: [{}],
    unitList: [],
    unitListCopy: [],
    checkedRows: [],
    allUnits: [],
    filterBy: '',
    unitIds: [],
    unitID: null,
    unitGroupUnitID: null,
    selectedID: null,
    selectedUnitGroupID: null,
    selectedUnitGroup: null,
    selectedUnitGroupUnit: null,
    formShow: false,
    action: '',
    showDetailIcon: true,
    selectedParentClass: 'is-selected',
    normalParentClass: '',
    clearName: false,
    showUnitGroupModal: false,
    showUnitGroupUnitModal: false,
    checkboxPosition: 'left',

    //activeTable: {
    region: {},
    filters: {
      show: false
    },
    expandableRows: true,
    columns: [
      {
        field: 'id',

        label: 'ID',
        aria: 'ID',
        width: '5%',
        numeric: true,
        sortable: true,
        searchable: true
      },
      {
        field: 'name',

        label: 'Name',
        aria: 'Name',
        width: '5%',
        sortable: true,
        searchable: true
      },
      {
        field: 'modifiedDate',
        date: true,

        label: 'Modification Date',
        aria: 'Modification Date',
        width: '5%',
        sortable: true,
        searchable: true
      },
      {
        field: 'actions',
        label: 'Actions',
        aria: 'Actions',
        width: '5%'
      }
    ],
    rows: []
  }
  //s}
}
